import request from '@/libs/http/index'

// 卡项---------
export const cardPage = params => {
  return request.get({
    url: `/clinic/card/page`,
    params,
  })
}
export const cardDetail = params => {
  return request.get({
    url: `/clinic/card/get`,
    params,
  })
}
export const cardCreate = data => {
  return request.post({
    url: `/clinic/card/create`,
    data,
  })
}
export const cardUpdate = data => {
  return request.put({
    url: `/clinic/card/update`,
    data,
  })
}
export const cardDelete = params => {
  return request.delete({
    url: `/clinic/card/delete`,
    params,
  })
}

// 患者卡项
export const patientCardPage = params => {
  return request.get({
    url: `/clinic/patient-card/page`,
    params,
  })
}
export const patientCardDetail = params => {
  return request.get({
    url: `/clinic/patient-card/get`,
    params,
  })
}
export const patientCardCreate = data => {
  return request.post({
    url: `/clinic/patient-card/create`,
    data,
  })
}
export const patientCardUpdate = data => {
  return request.put({
    url: `/clinic/patient-card/update`,
    data,
  })
}
export const patientCardDelete = params => {
  return request.delete({
    url: `/clinic/patient-card/delete`,
    params,
  })
}
export const patientCardRefund = data => {
  return request.post({
    url: `/clinic/patient-card/refund`,
    data,
  })
}
export const patientCardRecordPage = params => {
  return request.get({
    url: `/clinic/patient-card-record/page`,
    params,
  })
}
